<template>
  <div>
    <p class="my-5">
      <slot name="intro_text">Click on the button below to download the certificate</slot>
    </p>
    <button
      class="btn btn-primary btn-size-medium w-full lg:w-auto"
      @click="downloadCTCertificate"
      :disabled="uploadedCertificateUrl"
    >
      Use Certificate from School Careers Website
    </button>
    <vs-progress indeterminate color="primary" v-if="downloadingCTCertificate"></vs-progress>
  </div>
</template>

<script>
import store from '@/store/store';
import theApi from '@/mixins/theApi';

export default {
  computed: {
    uploadedCertificateUrl() {
      return store.getters['authStudent/preworkWorkplaceSafety'];
    },
  },
  data() {
    return {
      downloadingCTCertificate: false,
    };
  },
  methods: {
    async downloadCTCertificate() {
      this.downloadingCTCertificate = true;
      theApi.methods
        .makeCall(false, 'workplace_safety/useCertificate', 'get', null, false, true)
        .then(
          (data) => {
            if (data.status == 'OK') {
              store.commit('authStudent/preworkSetWSCert', data.url);
              const pw_data = {
                status_section: 'section_ws',
                section: 'workplace_safety_url',
                data: data.url,
                application_type: null,
              };
              store.dispatch('authStudent/completePreworkSection', pw_data);
              this.downloadingCTCertificate = false;
            }
          },
          () => {
            this.downloadingCTCertificate = false;
          },
        );
    },
  },
};
</script>
